import { getHidratationKey } from '@portal-internet/core';
import clsx from 'clsx';
import InnerHTML from 'dangerously-set-html-content';
import { useScript } from 'hooks/useScript';
import { useState } from 'react';
import __isEmpty from 'lodash/isEmpty';
import styles from './textDesplegable.module.scss';
import Icona from 'components/corporatiu/ui/Icona';

export default function TextDesplegable(props) {
    const { mida, text = '', className = null, estil = null } = props;
    const { isJavaScriptClientEnabled } = useScript();
    const [isDesplegat, setIsDesplegat] = useState(false);

    const handleToggleDesplegable = () => {
        setIsDesplegat(!isDesplegat);
    };

    const stylesText = clsx({
        [styles.text]: true,
        [styles[estil]]: !__isEmpty(estil),
        [styles[mida]]: !__isEmpty(mida),
        [className]: !__isEmpty(className)
    });

    const stylesTextDesplegable = clsx({
        [styles.text]: true,
        [styles.desplegable]: true,
        [styles[estil]]: !__isEmpty(estil),
        [styles[mida]]: !__isEmpty(mida),
        [className]: !__isEmpty(className),
        [styles.visible]: isDesplegat
    });

    const stylesbotoDesplegable = clsx({
        [styles.botoDesplegable]: true,
        [styles.visible]: isDesplegat
    });

    const cleanText = text.replace(/<!--.*?-->/g, '');
    const firstPMatch = cleanText.match(/^(<p[^>]*>.*?<\/p>)([\s\S]*)$/);
    const firstP = firstPMatch ? firstPMatch[1] : '';
    const restContent = firstPMatch ? firstPMatch[2] : cleanText;

    if (isJavaScriptClientEnabled && restContent) {
        return (
            <>
                {firstP && <InnerHTML className={stylesText} html={firstP} key={getHidratationKey(firstP)} />}
                <button className={stylesbotoDesplegable} onClick={handleToggleDesplegable} aria-expanded={isDesplegat}>
                    <Icona className={styles.icona} icona='fletxa_simple_avall' alt='llegir més contingut' isBlanc={true} />
                </button>
                <InnerHTML className={stylesTextDesplegable} html={restContent} key={getHidratationKey(restContent)} />
            </>
        );
    }

    return <></>;
}
